module.exports = __webpack_public_path__ + "img/check.5bbf2e44.svg";